<template>
  <vs-popup
    class="modal-tele"
    title="Visual Data Telemetry"
    :active.sync="viewTelemetry"
    @vs-close="closeForm">
    <div v-if="vehicle_category == 'Bus'" style="position: relative">
      <img :src="FMSBus" alt="" width="100%" />
      <img
        :src="Abnormal_MB_LWN"
        v-if="selectedLocation.main_battery_status == 'ABNORMAL'"
        alt=""
        width="55px"
        style="position: absolute; top: 200px; left: 275px" />
      <img
        :src="Normal_MB_LWN"
        v-if="selectedLocation.main_battery_status == 'NORMAL'"
        alt=""
        width="55px"
        style="position: absolute; top: 200px; left: 275px" />
      <img
        :src="Abnormal_OVERRPM"
        v-if="selectedLocation.engine_rpm_status == 'ABNORMAL'"
        style="position: absolute; top: 129px; left: 47px"
        alt=""
        width="55px" />
      <img
        :src="Normal_OVERRPM"
        v-if="selectedLocation.engine_rpm_status == 'NORMAL'"
        style="position: absolute; top: 129px; left: 47px"
        alt=""
        width="55px" />
      <img
        :src="Abnormal_OVERTEMP"
        v-if="selectedLocation.engine_temperature_status == 'ABNORMAL'"
        alt=""
        width="55px"
        style="position: absolute; top: 110px; right: 4px" />
      <img
        :src="Normal_OVERTEMP"
        v-if="selectedLocation.engine_temperature_status == 'NORMAL'"
        alt=""
        width="55px"
        style="position: absolute; top: 110px; right: 4px" />
    </div>
    <div v-if="vehicle_category == 'Passanger'" style="position: relative">
      <img :src="FMSPassenger" alt="" width="100%" />
      <img
        :src="Abnormal_MB_LWN"
        v-if="selectedLocation.main_battery_status == 'ABNORMAL'"
        alt=""
        width="45px"
        style="position: absolute; top: 126px; left: 118px" />
      <img
        :src="Normal_MB_LWN"
        v-if="selectedLocation.main_battery_status == 'NORMAL'"
        alt=""
        width="45px"
        style="position: absolute; top: 126px; left: 118px" />
      <img
        :src="Abnormal_OVERRPM"
        v-if="selectedLocation.engine_rpm_status == 'ABNORMAL'"
        style="position: absolute; top: 120px; left: 198px"
        alt=""
        width="45px" />
      <img
        :src="Normal_OVERRPM"
        v-if="selectedLocation.engine_rpm_status == 'NORMAL'"
        style="position: absolute; top: 120px; left: 198px"
        alt=""
        width="45px" />
      <img
        :src="Abnormal_OVERTEMP"
        v-if="selectedLocation.engine_temperature_status == 'ABNORMAL'"
        alt=""
        width="45px"
        style="position: absolute; top: 146px; left: 49px" />
      <img
        :src="Normal_OVERTEMP"
        v-if="selectedLocation.engine_temperature_status == 'NORMAL'"
        alt=""
        width="45px"
        style="position: absolute; top: 146px; left: 49px" />
    </div>
    <div
      v-if="vehicle_category == 'Truck'"
      style="position: relative; text-align: center">
      <img :src="FMSTruck" alt="" width="90%" />
      <img
        :src="Abnormal_MB_LWN"
        v-if="selectedLocation.main_battery_status == 'ABNORMAL'"
        alt=""
        width="50px"
        style="position: absolute; top: 245px; left: 330px" />
      <img
        :src="Normal_MB_LWN"
        v-if="selectedLocation.main_battery_status == 'NORMAL'"
        alt=""
        width="50px"
        style="position: absolute; top: 245px; left: 330px" />
      <img
        :src="Abnormal_OVERRPM"
        v-if="selectedLocation.engine_rpm_status == 'ABNORMAL'"
        style="position: absolute; top: 151px; left: 91px"
        alt=""
        width="50px" />
      <img
        :src="Normal_OVERRPM"
        v-if="selectedLocation.engine_rpm_status == 'NORMAL'"
        style="position: absolute; top: 151px; left: 91px"
        alt=""
        width="50px" />
      <img
        :src="Abnormal_OVERTEMP"
        v-if="selectedLocation.engine_temperature_status == 'ABNORMAL'"
        alt=""
        width="50px"
        style="position: absolute; top: 183px; left: 49px" />
      <img
        :src="Normal_OVERTEMP"
        v-if="selectedLocation.engine_temperature_status == 'NORMAL'"
        alt=""
        width="50px"
        style="position: absolute; top: 183px; left: 49px" />
    </div>
    <vs-divider />
    <vs-row style="background: #f8f8f8; padding-top: 5px">
      <vs-col vs-lg="6" vs-xs="12" style="padding: 0 5px">
        <vs-row>
          <vs-col vs-lg="3" vs-xs="6" style="padding: 0 5px">
            <div class="label-tele">License Plate</div>
            <div class="word-tele">{{ selectedLocation.license_plate }}</div>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="6" style="padding: 0 5px">
            <div class="label-tele">Vehicle Brand​</div>
            <div class="word-tele">{{ selectedLocation.vehicle_brand }}</div>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="6" style="padding: 0 5px">
            <div class="label-tele">Vehicle Model​</div>
            <div class="word-tele">{{ selectedLocation.vehicle_model }}</div>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="6" style="padding: 0 5px">
            <div class="label-tele">Total odometer</div>
            <div class="word-tele">
              {{ bulatin(selectedLocation.total_odometer / 1000) }}
            </div>
          </vs-col>
        </vs-row>
      </vs-col>

      <vs-col vs-lg="2" vs-xs="4" style="padding: 0 5px">
        <div class="label-tele">External Battery​</div>
        <div class="word-tele" v-if="vehicle_category != 'Passanger'">
          <span
            class="indikator-abnormal"
            v-if="selectedLocation.external_power_voltage < 24"></span>
          <span
            class="indikator-normal"
            v-if="selectedLocation.external_power_voltage >= 24"></span>

          {{ bulatin(selectedLocation.external_power_voltage) }} V
        </div>
        <div class="word-tele" v-if="vehicle_category == 'Passanger'">
          <span
            class="indikator-abnormal"
            v-if="selectedLocation.external_power_voltage < 12"></span>
          <span
            class="indikator-normal"
            v-if="selectedLocation.external_power_voltage >= 12"></span>

          {{ bulatin(selectedLocation.external_power_voltage) }} V
        </div>
      </vs-col>
      <vs-col vs-lg="2" vs-xs="4" style="padding: 0 5px">
        <div class="label-tele">Engine RPM</div>
        <div class="word-tele">
          <span
            class="indikator-abnormal"
            v-if="selectedLocation.engine_speed_x > 2500"></span>
          <span
            class="indikator-normal"
            v-if="selectedLocation.engine_speed_x <= 2500"></span>

          {{ selectedLocation.engine_speed_x }} RPM
        </div>
      </vs-col>
      <vs-col vs-lg="2" vs-xs="4" style="padding: 0 5px">
        <div class="label-tele">Engine Temperature​</div>
        <div class="word-tele">
          <span
            class="indikator-abnormal"
            v-if="selectedLocation.engine_coolant_temperature_x > 1000"></span>
          <span
            class="indikator-normal"
            v-if="selectedLocation.engine_coolant_temperature_x <= 1000"></span>

          {{ checkSuhu(selectedLocation.engine_coolant_temperature_x) }}
          <sup>o</sup>C
        </div>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
import FMSBus from '../../assets/Icon-baru/FMS-Bus.png'
import FMSPassenger from '../../assets/Icon-baru/FMS-Passenger.png'
import FMSTruck from '../../assets/Icon-baru/FMS-Truck.png'
import Abnormal_MB_LWN from '../../assets/images/telemetry/Abnormal_MB_LWN.png'
import Abnormal_OVERRPM from '../../assets/images/telemetry/Abnormal_OVERRPM.png'
import Abnormal_OVERTEMP from '../../assets/images/telemetry/Abnormal_OVERTEMP.png'
import Normal_MB_LWN from '../../assets/images/telemetry/Normal_MB_LWN.png'
import Normal_OVERRPM from '../../assets/images/telemetry/Normal_OVERRPM.png'
import Normal_OVERTEMP from '../../assets/images/telemetry/Normal_OVERTEMP.png'

export default {
  data() {
    return {
      Abnormal_MB_LWN: Abnormal_MB_LWN,
      Abnormal_OVERRPM: Abnormal_OVERRPM,
      Abnormal_OVERTEMP: Abnormal_OVERTEMP,
      Normal_MB_LWN: Normal_MB_LWN,
      Normal_OVERRPM: Normal_OVERRPM,
      Normal_OVERTEMP: Normal_OVERTEMP,
      jenis: 'Truck',
      FMSBus: FMSBus,
      FMSPassenger: FMSPassenger,
      FMSTruck: FMSTruck,
    }
  },
  props: {
    viewTeleModal: {
      type: Boolean,
      required: true,
    },
    title: String,
    allData: Array,
    dataLevel: Array,
    vehicle_category: String,
    editMode: Boolean,
    dataEdit: Object,
    selectedLocation: Object,
  },

  watch: {},
  computed: {
    viewTelemetry: {
      get() {
        //
        if (this.viewTeleModal && this.editMode) {
        }
        return JSON.parse(this.viewTeleModal)
      },
      set(val) {
        if (!val) {
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },

  methods: {
    bulatin(val) {
      return Math.round(parseInt(val))
    },
    checkSuhu(val) {
      let tmp = val
      if (parseInt(val) > 99) {
        tmp = Math.round(parseInt(val) / 10)
      }
      return tmp
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
  },
}
</script>

<style>
.indikator-normal {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #28d628;
  display: inline-block;
}

.indikator-abnormal {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #e30819;
  display: inline-block;
}

sup {
  color: red;
}

.label-tele {
  line-height: 1;
  font-size: 12px;
}

.word-tele {
  font-size: 15px;
  font-weight: bold;
}

.modal-tele .vs-popup {
  width: 900px !important;
}
</style>
